import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const MinusIcon = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="minus-icon"
      className={className}
      width="46"
      height="47"
      viewBox="0 0 46 47"
    >
      <path d="M42.1673 22.8285V23.7869C42.1673 24.8454 41.3092 25.7035 40.2507 25.7035H5.75065C4.69211 25.7035 3.83398 24.8454 3.83398 23.7869V22.8285C3.83398 21.77 4.69211 20.9119 5.75065 20.9119H40.2507C41.3092 20.9119 42.1673 21.77 42.1673 22.8285Z" />
    </svg>
  ),
  arePropsEqual
);

export default MinusIcon;
